import { Route, Switch } from 'react-router-dom';
import React from 'react';
import AppointmentView from './scenes/View';

const AppointmentRouter = ({ history, match }) => {
  return (
    <Switch>
      <Route
        exact
        path={`${match.url}/:id`}
        render={(props) => <AppointmentView history={history} match={match} {...props} />}
      />
    </Switch>
  );
};

export default AppointmentRouter;
